import { render, staticRenderFns } from "./ThgCreateOverviewCard.vue?vue&type=template&id=d98c4292"
import script from "./ThgCreateOverviewCard.vue?vue&type=script&lang=ts"
export * from "./ThgCreateOverviewCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgCreateOverviewCard.vue?vue&type=style&index=0&id=d98c4292&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports